// Copyright (C) 2021 TANNER AG

import gql from "graphql-tag";

export const FullEMobilityChapterFragment = gql`
    fragment FullEMobilityChapterFragment on EMobilityChapter {
        id
        title
        slug
        intro
        order
        eMobilityContents {
            order
            title
            content
            table
            quote
            info
            assetWithDescriptions(orderBy: sortIndex_ASC) {
                id
                asset(locales: [$lang, de]) {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }

                description
                localizedAsset {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }
            }
            image(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }
            hotspots(orderBy: sortIndex_ASC) {
                posX
                posY
                headline
                description
            }
            twoColumns
            youTubeLink
        }
        eMobilityTopic {
            id
            slug
            title
            order
            intro
            eMobilityChapters(orderBy: order_ASC) {
                id
                slug
                order
                title
            }
        }
    }
`;

export default gql`
    query EMobilityChapter($slug: String!, $lang: Locale!, $stage: Stage!) {
        eMobilityChapter(where: { slug: $slug }, locales: [$lang], stage: $stage) {
            ...FullEMobilityChapterFragment
        }
    }
    ${FullEMobilityChapterFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/eMobilityChapter.js